module.exports = __webpack_public_path__ + "img/f6s.0e517203.svg";